import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as mobxReact from 'mobx-react';
import { SingleSelectButton } from '../../../../../global/single-select/single-select-button';
import { ConnectionType } from '../../../../../../api/connections.dao';
import { ConnectionTemplatesFormVM, IDetailsItemField } from '../../connection-template-form.viewmodel';
import { OERadioSingleOption } from '../../../../../global/oe-radio-options/oe-radio-single-option';
import { ConnectionTemplatesDetailsItem } from './connection-template-details-item';
import { IAudioBridgeConnection, IKnovioConnection, IOtherConnection, IZoomConnection, IZoomWebinarConnection, TConnection } from '../../../../../../api/blueprints/connection.template.types';
import { connectGlobalVM } from '../../../../../global.context';
import { CONNECTIONS_SETTINGS_TEXT, INPUT_CONNECTIONS_TEXT, INPUT_DEFAULT_TEXT, REMOVE_BUTTON_SMALL_TEXT } from './conections-list.texts';
import { getConnectionTemplateItemLabelText } from '../../../../../../infrastructure/utils/connections.utils';

interface IProps {
    getGroupNameById: (id: number) => string;
}

interface IOwnProps {
    vm: ConnectionTemplatesFormVM;
}

export const ConnectionTemplatesListContainer = mobxReact.observer((props: IProps & IOwnProps) => {
    const formVM = props.vm;

    const composeProperDetails = (connection: TConnection): IDetailsItemField[] => {
        const { vm } = props;
        switch (connection.type) {
            case ConnectionType.Zoom:
                const zoomGroupName = props.getGroupNameById((connection as IZoomConnection).zoomGroupId);
                return vm.composeZoomMeetingConnectionDetails(connection as IZoomConnection, zoomGroupName);
            case ConnectionType.Webinar:
                const webinarGroupName = props.getGroupNameById((connection as IZoomWebinarConnection).zoomGroupId);
                return vm.composeZoomWebinarConnectionDetails(connection as IZoomWebinarConnection, webinarGroupName);
            case ConnectionType.Knovio:
                return vm.composeKnovioConnectionDetails(connection as IKnovioConnection);
            case ConnectionType.Other:
                return vm.composeOtherConnectionDetails(connection as IOtherConnection);
            case ConnectionType.AudioBridge:
                return vm.composeAudiBeidgeConnectionDetails(connection as IAudioBridgeConnection);
        }
    };

    return (
        <div className='connection-list connection-list__meeting-connections'>
            <div className='connection-list__label-wrapper'>
                <div className='connection-list__label connection-list__label--wide'>
                    <FormattedMessage {...INPUT_CONNECTIONS_TEXT} />
                </div>
                <div className='connection-list__label connection-list__label--greyed'>
                    <FormattedMessage {...INPUT_DEFAULT_TEXT} />
                </div>
                <div className='connection-list__label m-left-10px connection-list__label--mr'>
                    <FormattedMessage {...CONNECTIONS_SETTINGS_TEXT} />
                </div>
            </div>
            {!!formVM.connections && formVM.connections.map((connection: TConnection) => {
                const connectionLabel = getConnectionTemplateItemLabelText(connection);

                return (
                    <div className='connection-list__connection-wrapper' key={connection.connectionId}>
                        <ConnectionTemplatesDetailsItem
                            fields={composeProperDetails(connection)}
                            label={connectionLabel}
                            type={connection.type}
                            editConnection={formVM.openEditConnectionForm.bind(null, connection)}
                            removeConnection={formVM.removeConnection.bind(null, connection)}
                            configurePassportDisplay={formVM.configurePassportDisplay.bind(null, connection)}
                        />
                        <div className='connection-item__radio-default'>
                            <OERadioSingleOption
                                checked={connection.isDefaultConnection}
                                value={connection.connectionId}
                                onToggle={formVM.setDefaultConnection.bind(null, connection)}
                                allowUncheck={true}
                            />
                        </div>
                        <div className='connection-list__settings-value'>
                            {props.vm.getConnectionSettingsValue(connection)}
                        </div>
                        <div
                            onClick={formVM.removeConnection.bind(null, connection)}
                            data-test-id="connection-delete-button"
                        >
                            <label className='organization__remove-label m-right-10px'>
                                <FormattedMessage {...REMOVE_BUTTON_SMALL_TEXT} />
                            </label>
                        </div>
                    </div>

                );
            })}

            <SingleSelectButton
                className='default-button add-line-to-table-btn'
                items={props.vm.availableConnectionsItems}
                value='+ Add Connection'
                onChange={formVM.onConnectionTypeSelection}
                nameProperty='name'
                keyProperty='id'
            />
        </div>
    );
});

const ConnectionTemplatesList = connectGlobalVM<IProps, IOwnProps>(ConnectionTemplatesListContainer, vm => {
    return {
        getGroupNameById: vm.getGroupsVM().getGroupNameById
    };
});

export { ConnectionTemplatesList };
